import { render, staticRenderFns } from "./BuySpotsModal.vue?vue&type=template&id=3fe01ca6&scoped=true&"
import script from "./BuySpotsModal.vue?vue&type=script&lang=js&"
export * from "./BuySpotsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe01ca6",
  null
  
)

export default component.exports